import { render, staticRenderFns } from "./DiscreteStudyGD.vue?vue&type=template&id=3e2c1832&scoped=true&"
import script from "./DiscreteStudyGD.vue?vue&type=script&lang=js&"
export * from "./DiscreteStudyGD.vue?vue&type=script&lang=js&"
import style0 from "./DiscreteStudyGD.vue?vue&type=style&index=0&id=3e2c1832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2c1832",
  null
  
)

export default component.exports